import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
}
const _hoisted_2 = { class: "relative w-auto my-6 mx-auto max-w-sm" }
const _hoisted_3 = { class: "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-dark outline-none focus:outline-none" }
const _hoisted_4 = {
  key: 0,
  class: "bg-red-600 text-zinc-50 font-bold px-5 py-3 rounded-t-lg"
}
const _hoisted_5 = { class: "flex items-start justify-between p-5 border-solid border-blueGray-200 rounded-t" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-semibold text-gray-50" }, " Login ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "bg-transparent text-gray-100 h-6 w-6 text-2xl block outline-none focus:outline-none" }, " × ", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "relative p-6 flex-auto" }
const _hoisted_10 = {
  key: 1,
  class: "mx-auto mt-2"
}
const _hoisted_11 = { class: "flex items-center justify-end p-6 border-solid border-blueGray-200 rounded-b" }
const _hoisted_12 = {
  key: 0,
  class: "opacity-25 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCube = _resolveComponent("LoaderCube")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "pop" }, {
      default: _withCtx(() => [
        (_ctx.authLoginModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.loginMessage.message)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.loginMessage.message), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("button", {
                      class: "p-1 ml-auto bg-transparent border-0 text-white float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal()))
                    }, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "username",
                      class: "bg-bgDark text-gray-50 px-4 py-2 my-2 rounded-md focus:outline-none w-full",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.username) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.credentials.username]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      placeholder: "password",
                      class: "bg-bgDark text-gray-50 px-4 py-2 my-2 rounded-md focus:outline-none w-full",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.credentials.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.credentials.password]
                    ])
                  ]),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_LoaderCube)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "text-danger bg-transparent font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleModal()))
                    }, " Close "),
                    _createElementVNode("button", {
                      class: "text-gray-50 bg-primary rounded hover:bg-gray-50 hover:text-primary font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login()))
                    }, " Login ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.authLoginModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
      : _createCommentVNode("", true)
  ]))
}